import { Detection } from 'src/data-capture/types';

// The id the detector gave the detected item. Each family member's copy of a joint detection carries
// the same one, so saving it from any of their reviews lands on the same item. A one-per-client
// record (personal details, health) merges into the client's own, so it never takes the detected id.
export const detectedEntityId = (detection: Detection): string | null => {
  if (!detection.isConflictable) {
    return null;
  }
  const id = detection.entity.fields.id;
  return typeof id === 'string' ? id : null;
};
